export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const FULL_NAME = "fullName";
export const ROLES = "roles";